import * as React from 'react';

import { cn } from '../../lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'border-input file:text-foreground placeholder:text-muted-foreground focus-visible:ring-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          /*
           * Fehlerhafte Felder markiert `aria-invalid` — hier und nicht je Formular, damit
           * „rot" überall dasselbe heißt und Lieferantenportal und Admin-App nicht mit zwei
           * Rot-Tönen auseinanderlaufen. Dass die Kennzeichnung an einem ARIA-Attribut hängt
           * statt an einer Klasse, ist der Punkt: Was der Screenreader als ungültig meldet,
           * ist genau das, was auch rot ist.
           */
          'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
